<template>
    <section class="automatic-recharge-view">
        <HeaderComponent :title="'Recarga Automática'" />

        <div class="balance-container">
            <div class="list-fields">
                <div v-for="(field, key) in fields" :key="key" class="list-field">
                    <h1 v-text="field"></h1>
                    <i class="fa fa-arrow-down icon" @click="sortFields(field)"></i>
                </div>
            </div>
            <div class="loading" v-if="loading" >
                <i class="fa fa-spinner fa-spin fa-2x fa-fw"></i>
            </div>
            <div class="list" v-else-if="getAutoRechargeList.length > 0">
                <div class="list-item" v-for="(item, key) in getAutoRechargeList" :key="key" @click="selectStore(item)">
                    <div class="list-item-field">
                        <h1 class="storeName" v-text="item.NMFAMILISALD"></h1>
                    </div>
                    <div class="list-item-field">
                        <h1 v-text="formatValue(item.VRMINSALDORRECAR)"></h1>
                    </div>
                    <div class="list-item-field">
                        <h1 v-text="formatValue(item.VRRECARGARAUT)"></h1>
                    </div>
                </div>
            </div>
            <div class="not-found"  v-else>
                Não foram encontrados resultados
            </div>
        </div>

        <RechargeValueComponent
            ref="rechargeValueComponent"
            :storeName="selectedStore.NMFAMILISALD"
            :showMinValue="true"
            :initailMinValue="selectedStore.VRMINSALDORRECAR"
            :initialRechargeValue="selectedStore.VRRECARGARAUT"
            :showDeleteButton="true"
            @updateValue="updateValues"
            @deleteRecharge="deleteRecharge"
        />

        <ModalInfo @actionTrue="action"/>
    </section>
</template>

<script>
import HeaderComponent from '@/components/header/HeaderComponent.vue'
import RechargeValueComponent from '@/components/bottom-popups/RechargeValueComponent.vue'
import ModalInfo from '@/components/modals/ModalInfo.vue'
import { showErrorNotification, showSuccessNotification } from '@/libs/Util.js'
import { getAutoRechargeDetails, confirmAutoRecharge } from '@/components/controllers/AutoRechargeController'
import { mapActions, mapGetters } from 'vuex'

export default {
    name: 'AutomaticRechargeView',
    components: {
        HeaderComponent,
        RechargeValueComponent,
        ModalInfo
    },
    data () {
        return {
            fields: ['Loja', 'Valor Mínimo', 'Valor da Recarga'],
            selectedStore: {},
            isSorted: false,
            loading: false,
            values: {},
            blockRecharge: false,
            action: null
        }
    },
    computed: {
        ...mapGetters(['getAutoRechargeList'])
    },
    methods: {
        ...mapActions(['changeCardRechargeMenuVisibility', 'showModalInfo']),
        formatValue (value) {
            return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        },
        selectStore (store) {
            if (this.blockRecharge) {
                this.showModalInfo({
                    type: 'default',
                    text: 'Favor cadastrar um cartão de crédito antes de configurar uma recarga automática.',
                    icon: 'fas fa-xmark',
                    open: true
                })
                return
            }
            this.selectedStore = store
            this.changeCardRechargeMenuVisibility()
        },
        updateValues (value, minValue) {
            this.values = {
                value,
                minValue
            }

            this.action = this.confirmUpdate
            this.showModalInfo({
                type: 'defaultDialog',
                text: 'Confirma a realização de recargas automáticas no valor de ' + this.formatValue(value) + ' quando o saldo for inferior a  ' + this.formatValue(minValue) + '?',
                open: true
            })
        },
        confirmUpdate () {
            this.action = null
            confirmAutoRecharge(this.values.minValue, this.values.value, this.selectedStore.CDFAMILISALD).then((res) => {
                if (!res.rowsAffected) {
                    showErrorNotification({
                        title: '',
                        text: 'Erro ao configurar recarga automática. Tente novamente.'
                    })
                    return
                }
                this.changeCardRechargeMenuVisibility()
                showSuccessNotification({
                    title: '',
                    text: 'Recarga automática configurada.'
                })

                this.loading = true
                getAutoRechargeDetails().then(() => {
                    this.loading = false
                })
            })
            this.values = {}
        },
        sortFields: function (field) {
            this.isSorted = !this.isSorted
            const sortingField = field === 'Loja' ? 'NMFAMILISALD' : field === 'Valor Mínimo' ? 'VRMINSALDORRECAR' : 'VRRECARGARAUT'

            this.getAutoRechargeList.sort((a, b) => {
                if (this.isSorted) {
                    return a[sortingField] < b[sortingField] ? -1 : a[sortingField] > b[sortingField] ? 1 : 0
                } else {
                    return a[sortingField] > b[sortingField] ? -1 : a[sortingField] < b[sortingField] ? 1 : 0
                }
            })
        },
        deleteRecharge: function () {
            this.action = this.confirmDelete
            this.showModalInfo({
                type: 'defaultDialog',
                text: 'Deseja deletar a recarga automática configurada para a loja ' + this.selectedStore.NMFAMILISALD + '?',
                icon: 'fas fa-trash',
                open: true
            })
        },
        confirmDelete: function () {
            this.action = null
            confirmAutoRecharge(0, 0, this.selectedStore.CDFAMILISALD).then((res) => {
                if (!res.rowsAffected) {
                    showErrorNotification({
                        title: '',
                        text: 'Erro ao deletar recarga automática. Tente novamente.'
                    })
                    return
                }
                this.changeCardRechargeMenuVisibility()
                showSuccessNotification({
                    title: '',
                    text: 'Recarga automática deletada.'
                })

                this.loading = true
                getAutoRechargeDetails().then(() => {
                    this.loading = false
                })
            })
        }
    },
    mounted () {
        this.loading = true
        getAutoRechargeDetails().then((res) => {
            if (res.message) {
                this.blockRecharge = true
                this.showModalInfo({
                    type: 'default',
                    text: res.message.text,
                    icon: 'fas fa-circle-exclamation',
                    open: true
                })
            }
            this.loading = false
        })
    }
}
</script>

<style lang="less" scoped>
.balance-container {
    .list-fields {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        gap: 60px;
        margin-top: 40px;
        padding: 0 4px;
        h1 {
            margin-bottom: 10px;
            font-weight: 600;
        }

        .list-field {
            display: flex;
            flex-direction: row;
            align-items: baseline;

            h1 {
                margin-right: 4px;
            }
        }

    }

    .list {
        height: calc(100vh - 139px);
        overflow-y: auto;

        &::-webkit-scrollbar {
            display: none;
        }

        .list-item {
            display: grid;
            grid-template-columns: 1fr 1fr 1fr;
            gap: 60px;
            margin-top: 20px;
            padding: 20px 10px;
            border: 1px solid var(--cardBorder);
            box-shadow: 2px 2px 4px var(--cardBorder);
            border-radius: 5px;

            .list-item-field {
                word-break: break-all;
                h1 {
                    font-size: 16px;
                }
            }

            &:last-of-type {
                margin-bottom: 20px;
            }
        }
    }

    .not-found, .loading {
        display: flex;
        justify-content: center;
        h1 {
            font-weight: 600;
        }
    }
}

@media (max-width: 300px) {
    .balance-container {
        .list-fields {
            word-break: break-word;
        }
    }
}

</style>
